import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { CircularProgress, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  container: {
    margin: "10px",
    height: 35,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    "& > * + *": {
      marginLeft: theme.spacing(2),
    },
  },
  message: {
    marginTop: theme.spacing(2),
    color: theme.palette.text.secondary,
    textAlign: "center",
  },
}));

export default function CircularIndeterminate(props) {
  const classes = useStyles();
  const [showMessage, setShowMessage] = useState(false);

  useEffect(() => {
    if (props.showAlert === false) {
      setShowMessage(false);
      return;
    }

    const timer = setTimeout(() => {
      setShowMessage(true);
    }, 30000); // 30 seconds

    return () => {
      clearTimeout(timer);
      setShowMessage(false);
    };
  }, [props.showAlert]);

  return (
    <div
      className={
        props.useStyles ? props.useStyles().container : classes.container
      }
      style={{ height: "100%" }}
    >
      <CircularProgress size={props?.width ? props.width : 40} />
      {showMessage && (
        <Typography variant="body2" className={`${classes.message}`}>
          This is taking longer than expected. Please wait...
        </Typography>
      )}
    </div>
  );
}
